import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Row, Radio, Spin } from 'antd';
import SearchList from '../util/SearchList';

@inject('workflowStore', 'listStore',)
@observer
class App extends React.Component {
  static defaultProps = {
		prefixCls: 'case-search',
  }

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // const { workflowStore: { getTagsList } } = this.props;
    // getTagsList();
  }
  getParams = () => {
    const { workflowStore: { searchFormValue } } = this.props;
    let _searchFormValue = {...toJS(searchFormValue)};
    Object.keys(_searchFormValue).map(
      key => {
        _searchFormValue[key] || delete _searchFormValue[key]
      }
    )
    return _searchFormValue;
  }
  onSearch = () => {
    const { workflowStore: { getCaseList, params } } = this.props;
    getCaseList({
      ...toJS(params),
      ...this.getParams(),
    });
  }
  
  onReset = () => {
    const { workflowStore: { clearSearchValue } } = this.props;
    clearSearchValue();
    this.onSearch();
  }

  handleSelectChange = (value, key) => {
    const { onChange, workflowStore: { tagsSearch, getHotList, initTagsSearch } } = this.props;
    let obj = {
      [`${key}`]: value,
    };
    if(key === 'trade') {
      obj.function = 0;
    }
    typeof onChange === 'function' && onChange({ 
      ...toJS(tagsSearch),
      ...obj,
    });
    if(key === 'demotype') {
      initTagsSearch();
      getHotList();
    }
    this.onSearch();
  }
  render() {
    let {
			prefixCls,
      workflowStore: {
        tagsList,
        searchLoading,
        tagsSearch,
      },
		} = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    tagsSearch = toJS(tagsSearch);
    tagsList = toJS(tagsList);
    return (
			<div className={`${prefixCls}-header`}>
        {
          !searchLoading ?
            <Row className={`${prefixCls}-header-list`}>
              <SearchList 
                label="类型："
                className={`${prefixCls}-header-list-item workflow-tag`}
                datas={tagsList.demotype}
                radio
                selectKey={tagsSearch.demotype}
                onSelect={value => this.handleSelectChange(value, 'demotype')}
              />
              <SearchList
                label="行业："
                className={`${prefixCls}-header-list-item workflow-tag`}
                radio
                datas={tagsList.trade}
                selectKey={tagsSearch.trade}
                onSelect={value => this.handleSelectChange(value, 'trade')}
              />
              <SearchList
                label="职能："
                radio
                datas={tagsList.function}
                className={`${prefixCls}-header-list-item workflow-tag`}
                selectKey={tagsSearch.function}
                onSelect={value => this.handleSelectChange(value, 'function')}
              />
            </Row>
          : <Spin spinning={searchLoading}><div style={{height: 148}}></div></Spin>
        }
			</div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/workflow/Tags.js